import {
  PORTALEXTERIOR_ERROR,
  PORTALEXTERIOR_SUCCESS,
  PORTALEXTERIOR_LOADING,
  PORTALEXTERIOR_RESET,
  RESET_PORTAL_CONTEXT,
} from "../ActionTypes";
import portalExteriorPacienteInitialState from "../initialStates/portalExteriorPacienteInitialState";

const portalExterior = (state, { payload, type }) => {
  switch (type) {
    case PORTALEXTERIOR_LOADING:
      return {
        ...state,
        portalExterior: {
          ...state.portalExterior,
          error: false,
          loading: true,
        },
      };
    case PORTALEXTERIOR_SUCCESS:
      return {
        ...state,
        portalExterior: {
          ...state.portalExterior,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case PORTALEXTERIOR_ERROR:
      return {
        ...state,
        portalExterior: {
          ...state.portalExterior,
          error: payload,
          loading: false,
        },
      };

    case PORTALEXTERIOR_RESET:
      return portalExteriorPacienteInitialState;
    case RESET_PORTAL_CONTEXT:
      return portalExteriorPacienteInitialState;

    default:
      return state;
  }
};

export default portalExterior;
